import BestProductCardDetailed from './BestProductCardDetailed'

export default BestProductCardDetailed
